/**
 * Price Table
 */

export default function PriceTable() {
    const selectors = {
        'tabs' : '.js-price-table',
        'tab' : '.price-tab',
    };

    this.init = () => {
        this.handle();
    };

    this.move2Tab = ($tab, $parent) => {
        $parent.find(`#${$tab}`).removeClass('hide').siblings().addClass('hide');
        this.handleSlider();
    }

    this.handleTab = () => {
        if(!jQuery(selectors.tabs).length) return;
        jQuery(selectors.tabs).on('click', selectors.tab, (e) => {
            e.preventDefault();
            const $this = jQuery(e.target);
            let $tab = $this.data("tab");
            let $parent = $this.closest(selectors.tabs);
            $this.addClass('active').siblings().removeClass('active');
            this.move2Tab($tab, $parent);
        })
    }

    this.handleSlider = () => {
        if(!jQuery(selectors.tabs).length || jQuery(selectors.tabs).hasClass('js-not-use-slider')) return;

        jQuery(selectors.tabs).find('.price-content:visible:not(.slick-initialized)').each((index, item)=>{
            let total = jQuery(item).children().length;

            jQuery(item).slick({
                dots: false,
                arrows: false,
                infinite: false,
                speed: 300,
                slidesToShow: total,
                slidesToScroll: total,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            dots: true
                        }
                    }
                ]
            })
        })
    }

    this.handle = () => {
        this.handleTab();
        this.handleSlider();
    }


}
